<template>
  <van-nav-bar :border="flag" :fixed="true" :placeholder="true" class="head">
    <div slot="left">
      <van-icon  v-if="goBack" class="nav-h nav-left" name="arrow-left" @click="onClickLeft" />
    </div>
    <div slot="title" >
      <h2 class="title">{{title}}</h2>
    </div>
    <div slot="right">
      <van-icon  v-if="show=='search'"  @click="goSearch" >搜索</van-icon>
      <van-icon  v-if="show=='admin'" @click="goPersonal" name="manager" color="#fff" />
      <van-icon  v-else></van-icon>
    </div>
  </van-nav-bar>
</template>
<script>
export default {
  data() {
    return {
      flag:false,
    };
  },
  props: {
    goBack:{
      type:Boolean,
      default: false
    },
    title: {
      type: String,
      default: "xxxx"
    },
    show: {
      type: String,
      default: "xxxx"
    },
    backName: {
      type: String,
      default: ""
    },
    backPath: {
      type: String,
      default: ""
    }
  },
  mounted(){
  },
  methods: {
    // 控制弹框
    goSearch() {
       this.$emit("openSearch");
    },
    // 后退
    onClickLeft() {
      if (this.backUrl) {
        this.$router.push({name: this.backUrl})
      } else if (this.backPath) {
        this.$router.push({path: this.backPath})
      } else {
        this.$router.go(-1);
      }
    },
    //个人中心 
    goPersonal(){
       this.$router.push({name: 'personal'})
    }
  }
};
</script>

<style  scoped>
.nav-h {
  color:rgb(255, 248, 248) !important;
  font-size: 34px;
}
 .head{
  border-bottom: 2px solid #15c466;
  background-color: #13A556;
  z-index: 999 !important;
}
.van-nav-bar__title{
  text-align: center;
  font-size: 24px;
  line-height: 100px;
}
.van-nav-bar{
  height: 100px;
  line-height:100px;
}
.van-nav-bar__left{
  font-size: 30px;
  left:26px;
  text-align: left;
}
.van-nav-bar__right {
  font-size: 24px;
  right: 30px;
}
.title{
  font-size: 34px;
  color: rgb(255, 248, 248);
}
.van-nav-bar .van-icon{
  font-size: 32px;
}
</style>